import getHumanReadableFormattedDate from 'utils/dateAndTimes/formatters/getHumanReadableFormattedDate';
import getHumanReadableFormattedTimes from 'utils/dateAndTimes/formatters/getHumanReadableFormattedTimes';

const getHumanReadableFormattedDateAndTimes = ({
  valueFrom,
  valueTo,
  timezone,
  t,
  dateFormat,
}) => {
  const formattedDate = getHumanReadableFormattedDate({
    value: valueFrom,
    format: dateFormat,
    timezone,
    t,
  });

  const formattedTimes = getHumanReadableFormattedTimes({
    valueFrom,
    valueTo,
    timezone,
  });

  return `${formattedDate} ${formattedTimes}`;
};

export default getHumanReadableFormattedDateAndTimes;
